"use strict";

exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var utils_2 = require("../utils");
var generateAppConfig = function generateAppConfig(user) {
  var config = {};
  var gates = user.gates,
    features = user.features;
  var isBotsV2User = utils_1.getIsBotsV2User(gates);
  var needsToUpgradeForMarketo = ramda_1.pathOr(false, ['marketo_prompt_upgrade'], gates);
  var orgHasAudiences = !!gates.AUDIENCE;
  var hasAudiencesFeature = utils_2.hasFeature(features, {
    featureName: 'audiences',
    accessLevel: 'READ'
  });
  var hasContactsFeature = utils_2.hasFeature(features, {
    featureName: 'contacts',
    accessLevel: 'READ'
  });
  var hasAccountsFeature = utils_2.hasFeature(features, {
    featureName: 'accounts_page',
    accessLevel: 'READ'
  });
  var hasAllConvoViewWrite = utils_2.hasFeature(features, {
    featureName: 'convo_view_all',
    accessLevel: 'WRITE'
  });
  // Visitors Nav
  config = ramda_1.set(ramda_1.lensProp('hasAudiences'), orgHasAudiences && !isBotsV2User && hasAudiencesFeature, config);
  config = ramda_1.set(ramda_1.lensProp('hasContacts'), isBotsV2User || hasContactsFeature, config);
  config = ramda_1.set(ramda_1.lensProp('hasAccounts'), !isBotsV2User && hasAccountsFeature, config);
  // hiding live view within visitors subnav because it lives in activity feed nav now for rbac users
  config = ramda_1.set(ramda_1.lensProp('hasLiveView'), false, config);
  // Contacts-web
  config = ramda_1.set(ramda_1.lensProp('hasEnrollInSequence'), !isBotsV2User, config);
  config = ramda_1.set(ramda_1.lensProp('hasSendMessageButton'), !isBotsV2User && hasAllConvoViewWrite, config);
  if (isBotsV2User) {
    config = ramda_1.set(ramda_1.lensProp('hasMarketoAccess'), true, config);
  } else {
    config = ramda_1.set(ramda_1.lensProp('hasMarketoAccess'), !needsToUpgradeForMarketo, config);
  }
  return config;
};
exports["default"] = generateAppConfig;